import { ListaPedidos } from "@/pedidos/listaPedidos";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/pedidos/cerrados")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ListaPedidos url="/admin/pedidos/cerrados" />;
}
